<div class="min-h-screen flex items-center justify-center bg-gray-100 font-sans text-sm">
  <div class="w-full max-w-sm bg-white rounded-xl shadow-sm border p-8 space-y-6">
    <div class="text-center">
      <h1 class="text-2xl font-bold text-purple-800">Prijava:</h1>
      <p class="text-xs text-gray-500 mt-1">Uloguj se da nastaviš.</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-4">
      <div>
        <label class="block text-xs font-bold uppercase text-gray-500 mb-1">Email</label>
        <input
          formControlName="email"
          type="email"
          placeholder="ime@example.com"
          class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
          [class.border-red-500]="loginForm.controls.email.invalid && loginForm.controls.email.touched"
        />
        @if (loginForm.controls.email.invalid && loginForm.controls.email.touched) {
          <p class="text-xs text-red-600 mt-1">Unesi ispravnu email adresu.</p>
        }
      </div>

      <div>
        <label class="block text-xs font-bold uppercase text-gray-500 mb-1">Lozinka</label>
        <input
          formControlName="password"
          type="password"
          placeholder="••••••••"
          class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
          [class.border-red-500]="loginForm.controls.password.invalid && loginForm.controls.password.touched"
        />
        @if (loginForm.controls.password.invalid && loginForm.controls.password.touched) {
          <p class="text-xs text-red-600 mt-1">Lozinka mora imati najmanje 6 karaktera.</p>
        }
      </div>

      <button
        type="submit"
        [disabled]="loginForm.invalid"
        class="w-full py-2.5 bg-purple-600 text-white rounded-lg font-bold hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        Uloguj se
      </button>
    </form>
  </div>
</div>
